import { styled, Button, Popover, Menu, MenuItem, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react'
import TagFilter from '../filters/TagFilter';
import { Box } from '@mui/system';
import ClearIcon from '@mui/icons-material/Clear';
import { CancelOutlined } from '@mui/icons-material';
import CategoryFilter from '../filters/CategoryFilter';


const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  width: '250px'
}));

const StyledButton = styled(Button)(({ theme }) => ({
  color: '#333E48',
  fontSize: 17,
  fontWeight: 10,
  '&:hover': {
    backgroundColor: '#eeeeee',
  },
}));

const RemoveFiltersButton = styled(Button)(({ theme }) => ({
  width: '100%',
  backgroundColor: '#878a88',
  '&:hover': {
    backgroundColor: '#b9bdba', // Light grey background on hover
  },
  marginTop: theme.spacing(1.5)
}));

const getFiltersAndValues = (tags) => {
  const res = {};

  tags.forEach((tag) => {
    const [filter, value] = tag.split('_');
    if (filter && value) {
      if (!res[filter]) {
        res[filter] = [];
      }
      res[filter].push(value);
    }
  });
  return res;
};

const getEmptyTagValues = (tags) => {
  const res = {};

  tags.forEach((t) => {
    const tag = t.split('_')[0]
    if (!(tag in res)) {
      res[tag] = ''
    }
  });

  return res;
}

const TagsFilterWrapper = ({ setActiveFilters, tags, reset, categories, category, resetCategory }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filtersAndValues, setFiltersAndValues] = useState(null)
  const [tagValues, setTagValues] = useState({})
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (tags !== null) {
      setFiltersAndValues(getFiltersAndValues(tags))
      setTagValues(getEmptyTagValues(tags))
    }
  }, [tags])

  useEffect(() => {
    setActiveFilters(tagValues)
  }, [tagValues])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const setValues = (name, value) => {
    setTagValues({ ...tagValues, [name]: value })
  }

  const handleRemoveAllFilters = () => {
    const res = {}
    Object.keys(filtersAndValues).forEach((filterName) => {
      res[filterName] = ''
    });

    setActiveFilters(res)
    reset()
    handleClose()
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    filtersAndValues !== null ?
      <div>
        <StyledButton
          aria-controls={open ? 'filters-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          All filters
        </StyledButton>
        <Popover
          elevation={0}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton size="large" title='Refresh' onClick={handleClose}>
              <CancelOutlined fontSize="inherit" />
            </IconButton>
          </Box>
          <StyledBox>
            <CategoryFilter 
              key={-1}
              name={'Categories'}
              values={categories}
              category={category}
              resetCategory={resetCategory}
            />
            {
              Object.keys(filtersAndValues).map((filter) => (
                <TagFilter
                  key={filter}
                  name={filter}
                  values={filtersAndValues[filter]}
                  setValues={setValues}
                />
              ))
            }
            <RemoveFiltersButton variant='contained' endIcon={<ClearIcon />} onClick={handleRemoveAllFilters}>Remove all filters</RemoveFiltersButton>
          </StyledBox>

        </Popover>
      </div> :
      <></>
  );
}

export default TagsFilterWrapper